import React from "react";
import { LICENSE_TYPES, LICENSE_TYPE, DRAWDOWN_PRODUCTS_NAMES } from "license/constants";
const ProductsCell = ({ products, licenseType }) => {
  const formatSubject = (product) => LICENSE_TYPES[product];
  if (licenseType === LICENSE_TYPE.drawDown) {
    return /* @__PURE__ */ React.createElement(React.Fragment, null, products.split(",").map((product) => {
      if (!DRAWDOWN_PRODUCTS_NAMES[product]) return null;
      return /* @__PURE__ */ React.createElement("p", { key: product }, DRAWDOWN_PRODUCTS_NAMES[product]);
    }));
  }
  if (licenseType === LICENSE_TYPE.dailyUsage) {
    return /* @__PURE__ */ React.createElement("p", null, formatSubject(products));
  }
  return null;
};
export default ProductsCell;
